module.exports = __webpack_public_path__ + "static/media/information-delete.b2c78e1e.svg";